
// import ms101 from "./ms101"
import bankhome from "./bankhome"
import ApplicationTools from "./ApplicationTools";
import CustomerAndTransactions from "./Customers & Accounts";
import BankRC from "./BankRC";
import showroom4 from "./showroom4";
import showroom5 from "./showroom5"
import Enterprisecommon from "./Enterprisecommon";
import Election from "./Election";
import Reports from "./Reports";
import ControlSearch from "./ControlSearch";
import Transactions from "./Transactions";
import help from "./help";
import Agri from "./Agri";
import modalPages from "./modalPages";
import editor from "./editor";
// import abbtxnerror from "./Transactions/abbtxnerror"
// import ms201 from './ms201';
// import ms101e from "./ms101e"
import Parameters from "./Parameters";
import HO from "./HO";
import autogen from "./autogen";

import Banking from "./Banking";
export default {
  ...Banking,

  ...HO,
  ...autogen,
  ...Parameters,


  ...Agri,
  ...CustomerAndTransactions,
  ...ApplicationTools,
  ...BankRC,
  ...Enterprisecommon,
  ...Election,
  ...Reports,
  ...ControlSearch,
  ...Transactions,
  ...modalPages,
  help,
  // abbtxnerror,
  bankhome,
  showroom4,
  showroom5,
  editor,

  // ms201
};
